import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { toWords } from "number-to-words";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  tableCellHeader: {
    width: "4%",
    textAlign: "right",
    marginTop: "-4",
  },
  col: {
    flexDirection: "column",
  },
  boldText: {
    fontWeight: "bold",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    textAlign: "right",
    letterSpacing: 2,
  },
  poNumber: {
    fontSize: 10,
    textAlign: "right",
  },
  textSmall: {
    fontSize: 8,
    marginBottom: 2,
  },
  sectionTitle: {
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 2,
  },
  tableHeader: {
    backgroundColor: "#3A3A3A",
    fontWeight: "bold",
    flexDirection: "row",
    padding: 4,
  },
  tableRow: {
    flexDirection: "row",
    padding: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  cell: {
    padding: 2,
    fontSize: 7,
  },
  cellHeader: {
    fontSize: 8,
    fontWeight: "bold",
  },
  logo: {
    height: 60,
    width: 180,
    marginBottom: 10,
  },
  companyInfo: {
    marginBottom: 15,
  },
});

const InventoryPDFDoc = ({ vendor }) => {
  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${d.getFullYear()}`;
  };
  
  
  const today = new Date();
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling
  const [data, setData] = useState([]); // State to store table data
  const [totalDiscount, setTotalDiscount] = useState(0);
  
  // Add error handling for missing data
  if (!vendor) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Text>Error: No vendor data available</Text>
        </Page>
      </Document>
    );
  }
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={{ marginTop: 20 }}>
          {/* Logo and Company Info */}
          <View style={styles.row}>
            <View style={{ width: "60%" }}>
              <Image
                style={[styles.logo, { marginTop: 10 }]}
                src="/sadashri_logo-bnw.png"
              />
              <View style={styles.companyInfo}>
                <Text style={[styles.boldText, styles.textSmall]}>
                  Sadashri Ventures Private Limited
                </Text>
                <Text style={styles.textSmall}>
                  Flat No: 1323/1324, 16th B Cross Hosing
                </Text>
                <Text style={styles.textSmall}>
                  Board Colony EWS 3rd Phase, Yelahanka New
                </Text>
                <Text style={styles.textSmall}>
                  Town, Bengaluru Urban, Karnataka- 560064
                </Text>
                <Text style={styles.textSmall}>
                  CIN : U46498KA2024PTC185784
                </Text>
                <Text style={styles.textSmall}>GSTIN: 29ABMCS9253K1ZG</Text>
                <Text style={styles.textSmall}>sadashri.Yel@gmail.com</Text>
              </View>
            </View>
            {/* <View style={{ width: "40%", marginTop: 20 }}>
              <Text style={styles.title}>SALES ORDER</Text>
              <Text style={styles.poNumber}>{formData.order_number}</Text>
            </View> */}
          </View>
        </View>

        <View style={styles.col}>
          <View style={{ width: "80%" }}>
            <Text style={styles.sectionTitle}>Branch</Text>
            <Text style={styles.textSmall}>Sadashri Jewels</Text>
            <Text style={styles.textSmall}>
              Shop no. 1 No.2063, Dairy Circle, Asha Arcade,
            </Text>
            <Text style={styles.textSmall}>
              16th B Cross Rd, Yalahanka New Town, Bangalore- 560064
            </Text>
          </View>
        </View>

        <View
          style={[
            styles.row,
            { justifyContent: "space-between", marginTop: 10 },
          ]}
        >
          <View style={{ width: "55%" }}>
            {vendor && (
              <View style={[styles.row, { marginTop: 10 }]}>
                <View style={{ width: "55%" }}>
                  <Text style={styles.sectionTitle}>Vendor Info</Text>
                  <Text style={styles.textSmall}>
                    Name: {vendor.vendor?.vendor_name || 'N/A'}
                  </Text>
                  <Text style={styles.textSmall}>
                    Avg MC/Gram: ₹
                    {Number(vendor.vendor?.avg_mc_per_gram || 0).toFixed(2)}
                  </Text>
                  <Text style={styles.textSmall}>
                    Wastage: {vendor.vendor?.wastage_per || 0}%
                  </Text>
                </View>
              </View>
            )}
          </View>
          <View style={{ width: "25%", paddingLeft: 50, marginTop: 50 }}>
            <View
              style={{
                flexDirection: "row",
                //justifyContent: "space-between",
              }}
            >
              <Text style={styles.textSmall}>Date : </Text>
              <Text style={styles.textSmall}>{formatDate(today)}</Text>
            </View>
            {/* <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textSmall}>Delivery Date :</Text>
              <Text style={styles.textSmall}>
                {formatDate(new Date(today.setDate(today.getDate() + 15)))}
              </Text>
            </View> */}
          </View>
        </View>

        <View style={[styles.tableHeader]}>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>#</Text>
          <Text style={[styles.cell, { width: "20%", color: "white" }]}>
            Category
          </Text>
          <Text style={[styles.cell, { width: "20%", color: "white" }]}>
            Subcategory
          </Text>
          <Text style={[styles.cell, { width: "20%", color: "white" }]}>
            Product Design
          </Text>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>
            Qty
          </Text>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>
            Gross Wt
          </Text>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>
            Stone Wt
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Net Wt
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Purity
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Wastage %
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            MC
          </Text>
        </View>
        {vendor?.items && vendor.items.length > 0 ? (
          vendor.items.map((it, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.cell, { width: "5%" }]}>{index + 1}</Text>
              <Text style={[styles.cell, { width: "20%" }]}>
                {it.vendor?.category || ""}
              </Text>
              <Text style={[styles.cell, { width: "20%" }]}>
                {it.vendor?.sub_category || ""}
              </Text>
              <Text style={[styles.cell, { width: "20%" }]}>
                {it.vendor?.design_master || ""}
              </Text>
              <Text style={[styles.cell, { width: "5%" }]}>
                {it.vendor?.total_items || ""}
              </Text>
              <Text style={[styles.cell, { width: "5%" }]}>
                {it.item?.weightBW || ""}
              </Text>
              <Text style={[styles.cell, { width: "5%" }]}>
                {it.vendor?.stone_wt || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {it.item?.weightBW || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {it.vendor?.purity || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {it.vendor?.wastage_per || ""}
              </Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {it.vendor?.mc_amt ?? 0}
                {it.vendor?.mc_type === "MC %"
                  ? "%"
                  : it.vendor?.mc_type === "MC / Gram"
                  ? "/gm"
                  : ""}
              </Text>
            </View>
          ))
        ) : (
          <View style={styles.tableRow}>
            <Text style={[styles.cell, { width: "100%", textAlign: "center" }]}>
              No items found for this purchase order
            </Text>
          </View>
        )}

        <View style={[styles.row, { marginTop: 40 }]}>
          <Text>
            Authorized Signature{" "}
            <Text style={{ fontWeight: "bold" }}>____________________</Text>
          </Text>
          <Text>
            Sadashri Ventures Signature{" "}
            <Text style={{ fontWeight: "bold" }}>____________________</Text>
          </Text>
        </View>
      </Page>
    </Document>
  );
};
export default InventoryPDFDoc;
